import React from 'react';
import LevelnineCard from 'src/components/mainCard/LevelnineCard';
import VMKCard from 'src/components/mainCard/VMKCard';

export const mandantCards: Record<string, React.ReactElement<any, any>> = {
  LevelnineInfoBoxComponent: <LevelnineCard />,
  VMKInfoBoxComponent: <VMKCard />,
};

export default mandantCards;
